import { ChangeDetectionStrategy, Component, HostBinding, HostListener, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { MyOffersGameService } from "./my-offers-game.service";
import { MyOffersCustomEvent } from "./my-offers.model";

@Component({
	selector: "obg-app-my-offers-lobby",
	templateUrl: "./my-offers-lobby.component.html",
	styleUrls: ["./my-offers-lobby.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyOffersLobbyComponent implements OnDestroy {
	@HostBinding("class.obg-app-my-offers-lobby") hostCss = true;

	private launchGame$$: Subscription | undefined;

	constructor(private myOffersGameService: MyOffersGameService) {}

	@HostListener("myOffersEvent", ["$event"])
	handleMyOffersEvents({ detail: { name, data } }: CustomEvent<MyOffersCustomEvent>) {
		if (name === "launch-game") {
			const gameId = data?.gameId;
			if (!gameId) {
				return;
			}

			this.cancelLaunchGame();

			this.launchGame$$ = this.myOffersGameService.launchGame$(gameId).subscribe();
		}
	}

	ngOnDestroy() {
		this.cancelLaunchGame();
	}

	private cancelLaunchGame(): void {
		if (!this.launchGame$$) {
			return;
		}

		this.launchGame$$.unsubscribe();
		this.launchGame$$ = undefined;
	}
}
